/* Rugged Print, Module 10: SITE CHROME core (shared by both iterations).
   What lives here: the cart adapter (real Shopify Ajax Cart API, with a local stand-in for the preview), the search
   adapter (real Shopify predictive search, with a local stand-in), the layer manager (menu, Shop by Case, search,
   cart: one open at a time, focus, Escape, scroll lock), the footer Get Code form, quick-add hand-off, preview link
   routing, and mount(): it swaps the Module 6 stand-in header/footer for the chosen iteration's real chrome.

   REAL vs PREVIEW, decided once by hostname (LIVE below):
     on ruggedprint.com / *.myshopify.com   GET /cart.js, POST /cart/add.js, POST /cart/change.js, GET /products/<h>.js,
                                            GET /search/suggest.json, links navigate normally, the email form posts to
                                            Shopify's customer form. Nothing is mocked.
     anywhere else (localhost:4500)         the same calls go to a localStorage cart with the EXACT /cart.js shape
                                            (prices in cents, key, quantity, product_title, variant_title, final_line_price,
                                            image, url) built from the live catalog snapshot, so the drawer code is the
                                            code that ships. Links follow the preview link map and say what they do.
   Iteration files register RPC.impl = { top, footer, overlays, cartHTML, searchHTML, init }. */
(function(){
  var W = window, doc = document;
  var BASE = (doc.currentScript && doc.currentScript.src || location.href).replace(/[^/]*$/, '');
  var LIVE = /(^|\.)ruggedprint\.com$|\.myshopify\.com$/i.test(location.hostname);
  var RPC = W.RPC = W.RPC || {};
  RPC.LIVE = LIVE; RPC.BASE = BASE;
  var D = W.RPC_DATA;

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  RPC.esc = esc;
  /* cents -> "$40" / "$12.50" (locked currency rule: no trailing zeros) */
  RPC.money = function(c){ c = Math.round(c || 0); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
  RPC.variantLabel = function(v){
    if (!v || /^default title$/i.test(v)) return '';
    if (/insert only/i.test(v)) return 'Insert only';
    if (/insert \+ packout case/i.test(v)) return 'Insert + PACKOUT case';
    return v;
  };
  /* Shopify CDN resize (real images only; local files pass through) */
  RPC.img = function(src, w){ if (!src) return ''; return /cdn\.shopify\.com/.test(src) ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : src; };
  /* footer Get Code form. Live: a real Shopify customer (newsletter) form POST; Shopify returns to ?customer_posted=true.
     The code is shown on screen only while it is a REAL code: with codeIsPlaceholder the live store shows the thank-you
     line without any code (a visitor must never see WELCOME10 before it works at checkout). */
  RPC.codeForm = function(D, btnCls, id){
    var o = D.offer, showCode = !LIVE || !o.codeIsPlaceholder;
    return '<form class="rpc-code" data-rpc-code-form method="post" action="/contact#rpc-code" accept-charset="UTF-8" novalidate>' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="&#10003;"><input type="hidden" name="contact[tags]" value="newsletter,footer-10-off">' +
      '<div data-step="ask"><label class="sr-only" for="' + id + '">' + esc(o.emailLabel || 'Email address') + '</label>' +
      '<div class="rpc-code-row"><input class="rpc-code-in" id="' + id + '" name="contact[email]" type="email" placeholder="' + esc(o.ph) + '" autocomplete="email" required>' +
      '<button class="' + btnCls + '" type="submit">' + esc(o.btn) + ' <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></button></div>' +
      '<p class="rpc-fine">' + esc(o.fine) + '</p></div>' +
      '<div data-step="done" role="status" hidden><p class="rpc-code-h">' + esc(o.doneH) + '</p>' +
      (showCode ? '<p class="rpc-code-sub">' + esc(o.doneSub) + '</p><p class="rpc-code-code">' + esc(o.code) + '</p>' +
        (o.codeIsPlaceholder ? '<span class="rpc-pending">Placeholder code, not live. Real code pending (needs write_discounts)</span>' : '') : '') +
      '</div></form>';
  };
  /* small preview-only "pending" tag; never rendered on the live store */
  RPC.pending = function(text){ return LIVE ? '' : '<span class="rpc-pending">' + esc(text) + '</span>'; };
  /* AI-pipeline image? (filename pattern of the approved New Images/selected/ files: "-angle1.jpg"). Port: replace with
     a product metafield (custom.ai_reference_image) so the disclosure never depends on a filename. */
  RPC.isAI = function(src){ return /-angle\d/i.test(src || ''); };
  RPC.disclosure = function(D, cls){ return '<p class="' + (cls || 'rpc-discl') + '">* ' + esc(D.disclosure) + '</p>'; };
  /* keep PACKOUT model numbers (48-22-8435) on one line inside live product titles (input: already escaped) */
  RPC.models = function(html){ return String(html).replace(/(\d{2}-\d{2}-\d{4})/g, '<span class="rpc-nw">$1</span>'); };
  RPC.caseHref = function(c){ return D.caseLinkMode === 'hub' ? c.hubHref : c.href; };

  function toast(msg, ms){
    if (W.RP_ROUTES && RP_ROUTES.toast) return RP_ROUTES.toast(msg, ms);
    var t = doc.querySelector('.rp-toast');
    if (!t){ t = doc.createElement('div'); t.className = 'rp-toast'; t.setAttribute('role', 'status'); doc.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, ms || 4500);
  }
  RPC.toast = toast;

  /* ======================================================================
     CART ADAPTER
     ====================================================================== */
  function jfetch(url, opts){
    return fetch(url, opts).then(function(r){ return r.json().then(function(d){ if (!r.ok || d.status) throw new Error(d.description || d.message || 'Cart error'); return d; }); });
  }
  function post(url, body){ return jfetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify(body) }); }

  var MOCK_KEY = 'rpc_preview_cart_v1';
  var Mock = {
    load: function(){ try { return JSON.parse(localStorage.getItem(MOCK_KEY)) || { items:[] }; } catch(e){ return { items:[] }; } },
    save: function(st){ try { localStorage.setItem(MOCK_KEY, JSON.stringify(st)); } catch(e){} },
    cart: function(){
      var L = W.RPC_LOCAL_SEARCH, st = Mock.load(), items = [];
      st.items.forEach(function(it){
        var p = L && L.byHandle(it.handle); if (!p) return;
        var unit = (it.v === 'case' && p.casePrice ? p.casePrice : p.price) * 100;
        items.push({ key: it.handle + ':' + it.v, id: 0, quantity: it.q, handle: p.handle, url: p.url,
          product_title: p.title, variant_title: it.v === 'case' ? 'Yes - Insert + PACKOUT Case' : 'No - Insert Only',
          image: p.img, final_price: unit, final_line_price: unit * it.q, original_line_price: unit * it.q, line_level_discount_allocations: [] });
      });
      var sub = items.reduce(function(a, i){ return a + i.final_line_price; }, 0);
      return { item_count: items.reduce(function(a, i){ return a + i.quantity; }, 0), items: items, items_subtotal_price: sub,
        total_price: sub, total_discount: 0, cart_level_discount_applications: [], currency:'USD', _preview:true };
    },
    add: function(handle, qty, v){
      var st = Mock.load(), k = handle + ':' + (v || 'insert'), row = st.items.filter(function(i){ return i.handle + ':' + i.v === k; })[0];
      if (row) row.q += qty || 1; else st.items.push({ handle: handle, v: v || 'insert', q: qty || 1 });
      Mock.save(st); return Mock.cart();
    },
    change: function(key, qty){
      var st = Mock.load();
      st.items = st.items.filter(function(i){ if (i.handle + ':' + i.v === key){ i.q = qty; } return i.q > 0; });
      Mock.save(st); return Mock.cart();
    },
    clear: function(){ Mock.save({ items:[] }); return Mock.cart(); }
  };

  RPC.cart = {
    state: null,
    get: function(){ return (LIVE ? jfetch('/cart.js', { headers:{ 'Accept':'application/json' } }) : Promise.resolve(Mock.cart())).then(set); },
    /* items: [{ id: variantId, quantity }] (real variant IDs, e.g. the Bundle Kit's data-variant values) */
    add: function(items){
      if (!LIVE) return Promise.resolve(RPC.cart.state || Mock.cart()).then(function(){ toast('Preview: variant IDs only add on the live store. Use addHandle here.'); return RPC.cart.get(); });
      return post('/cart/add.js', { items: items }).then(function(){ return RPC.cart.get(); });
    },
    /* one product by handle: picks the "Insert Only" variant (live option "Include PACKOUT Case?"), else the first available */
    addHandle: function(handle, qty){
      if (!LIVE) return Promise.resolve(Mock.add(handle, qty || 1)).then(set);
      return jfetch('/products/' + encodeURIComponent(handle) + '.js').then(function(p){
        var v = p.variants.filter(function(x){ return x.available && /insert only/i.test(x.title); })[0] || p.variants.filter(function(x){ return x.available; })[0];
        if (!v) throw new Error('This insert is sold out right now.');
        return RPC.cart.add([{ id: v.id, quantity: qty || 1 }]);
      });
    },
    change: function(key, qty){
      if (!LIVE) return Promise.resolve(Mock.change(key, qty)).then(set);
      return post('/cart/change.js', { id: key, quantity: qty }).then(set);
    },
    clear: function(){ return LIVE ? post('/cart/clear.js', {}).then(set) : Promise.resolve(Mock.clear()).then(set); }
  };
  function set(cart){ RPC.cart.state = cart; paintCart(); return cart; }

  function paintCart(){
    var c = RPC.cart.state; if (!c) return;
    doc.querySelectorAll('[data-rpc-count]').forEach(function(el){ el.textContent = c.item_count; el.hidden = !c.item_count; });
    doc.querySelectorAll('[data-rpc-subtotal]').forEach(function(el){ el.textContent = RPC.money(c.total_price); });
    doc.querySelectorAll('[data-rpc-cartlabel]').forEach(function(el){ el.setAttribute('aria-label', 'Cart, ' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's')); });
    var body = doc.querySelector('[data-rpc-cartbody]');
    if (body && RPC.impl && RPC.impl.cartHTML) body.innerHTML = RPC.impl.cartHTML(c, D, RPC.freeShip(c));
  }
  /* free-shipping meter state. Hidden entirely on the live store until the real $65 rule exists (truth rule). */
  RPC.freeShip = function(c){
    var t = (D.settings.freeShip || 0) * 100;
    if (!t) return null;
    if (LIVE && !D.settings.freeShipRuleLive) return null;
    var have = c.total_price, left = Math.max(0, t - have);
    return { threshold:t, left:left, pct: Math.min(100, Math.round(have / t * 100)), done: left === 0, pending: !D.settings.freeShipRuleLive };
  };

  /* ======================================================================
     SEARCH ADAPTER
     ====================================================================== */
  RPC.suggest = function(q){
    if (!LIVE) return Promise.resolve(W.RPC_LOCAL_SEARCH ? W.RPC_LOCAL_SEARCH.suggest(q, D) : { products:[], collections:[], queries:[] });
    var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
    return jfetch(u).then(function(d){ var r = d.resources.results; return { products: r.products || [], collections: r.collections || [], queries: r.queries || [] }; });
  };
  RPC.searchUrl = function(q){ return LIVE ? '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last' : BASE + 'search.html?q=' + encodeURIComponent(q) + '&it=' + (doc.documentElement.getAttribute('data-rpc') || '1'); };

  /* ======================================================================
     PREVIEW LINK ROUTING (local only; on the live store every link just navigates)
     ====================================================================== */
  var M11 = BASE + '../module-11-content-pages-2026-10-15/', M12 = BASE + '../module-12-policy-pages-2026-10-15/';
  var LIVE_PAGES = {     // exist on ruggedprint.com today (checked 2026-10-15, HTTP 200); local redesign shown in a new tab
    '/pages/contact': M11 + 'contact.html', '/pages/faqs': M11 + 'faqs.html', '/pages/about-us': M11 + 'about.html',
    '/policies/refund-policy': M12 + 'refund.html', '/policies/shipping-policy': M12 + 'shipping.html',
    '/policies/privacy-policy': M12 + 'privacy.html', '/policies/terms-of-service': M12 + 'terms.html',
    '/pages/data-sharing-opt-out': M12 + 'data-sharing-opt-out.html'
  };
  RPC.go = function(href){
    var u = new URL(href, 'https://ruggedprint.com'), path = u.pathname;
    if (path === '/search'){ location.href = RPC.searchUrl(u.searchParams.get('q') || ''); return; }
    if (path === '/collections/packout-inserts'){
      W.open('https://ruggedprint.com' + path + u.search, '_blank');
      toast('Live now: ruggedprint.com' + path + u.search + ' opened in a new tab (the master collection, published 2026-10-15). It still wears today\'s old header until this chrome ships.', 8000);
      return;
    }
    if (LIVE_PAGES[path]){ W.open(LIVE_PAGES[path], '_blank'); toast('Live today at ruggedprint.com' + path + '. Preview opened its new-design version (Module 11/12) in a new tab.', 7000); return; }
    if (/^\/account/.test(path)){ toast('Live store only: Shopify customer accounts (ruggedprint.com/account, sign in with an emailed code). Works on the live domain today.', 7000); return; }
    if (path === '/checkout'){ toast('Live store only: on ruggedprint.com this goes straight to Shopify checkout with this exact cart.', 7000); return; }
    if (path === '/cart'){ RPC.open('cart'); return; }
    var root = doc.querySelector('[data-lp-root]');
    if (W.RP_ROUTES){ RP_ROUTES.handle(href, { page: root ? root.getAttribute('data-page') : 'search', frame:false, toast:toast }); return; }
    toast('Preview only: at launch this link opens ruggedprint.com' + href);
  };

  /* ======================================================================
     LAYERS: menu, cases, search, cart. One open at a time.
     ====================================================================== */
  var openName = null, opener = null;
  function layer(n){ return doc.querySelector('[data-rpc-layer="' + n + '"]'); }
  function focusables(el){ return Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'), function(x){ return x.offsetParent !== null || x === doc.activeElement; }); }
  RPC.open = function(n, btn, o){
    if (openName === n){ var C = layer(n); if (!(o && o.keepFocus) && Date.now() - ((C && C._t) || 0) > 600) RPC.close(); return; }
    RPC.close(true);
    var L = layer(n); if (!L) return;
    L._t = Date.now();
    openName = n; opener = btn || doc.activeElement;
    L.hidden = false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ L.classList.add('is-open'); }); });
    doc.querySelectorAll('[data-rpc-open="' + n + '"]').forEach(function(b){ b.setAttribute('aria-expanded', 'true'); });
    if (L.hasAttribute('data-modal')) doc.documentElement.classList.add('rpc-lock');
    doc.documentElement.setAttribute('data-rpc-showing', n);
    if (n === 'cart') RPC.cart.get();
    var f = L.querySelector('[data-rpc-focus]') || focusables(L)[0];
    if (!(o && o.keepFocus)) setTimeout(function(){ if (f && f.offsetParent !== null) f.focus({ preventScroll:true }); }, 60);
    if (RPC.impl.onOpen) RPC.impl.onOpen(n, L);
  };
  RPC.close = function(silent){
    if (!openName) return;
    var n = openName, L = layer(n); openName = null;
    doc.querySelectorAll('[data-rpc-open="' + n + '"]').forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
    doc.documentElement.classList.remove('rpc-lock'); doc.documentElement.removeAttribute('data-rpc-showing');
    if (L){ L.classList.remove('is-open'); setTimeout(function(){ if (openName !== n) L.hidden = true; }, 200); }
    if (!silent && opener && opener.focus) opener.focus({ preventScroll:true });
    if (RPC.impl.onClose) RPC.impl.onClose(n);
  };
  RPC.isOpen = function(){ return openName; };

  /* predictive search: debounced, last request wins */
  var qTimer = null, qSeq = 0;
  function runSuggest(input){
    var q = input.value.trim(), L = input.closest('[data-rpc-layer]') || layer(input.getAttribute('data-rpc-for') || 'search');
    var box = L && L.querySelector('[data-rpc-results]'); if (!box) return;
    clearTimeout(qTimer);
    qTimer = setTimeout(function(){
      var my = ++qSeq;
      if (!q){ box.innerHTML = RPC.impl.searchHTML(null, '', D); return; }
      RPC.suggest(q).then(function(r){ if (my === qSeq) box.innerHTML = RPC.impl.searchHTML(r, q, D); })
        .catch(function(){ if (my === qSeq) box.innerHTML = '<p class="rpc-sr-note">Search is not responding. Press Enter to see full results.</p>'; });
    }, q ? 180 : 0);
  }
  RPC.runSuggest = runSuggest;

  /* ======================================================================
     EVENTS (bound to the chrome's own elements, so the host page's link handler never sees chrome clicks)
     ====================================================================== */
  function onClick(e){
    var t = e.target;
    var op = t.closest('[data-rpc-open]');
    if (op){ e.preventDefault(); e.stopPropagation(); RPC.open(op.getAttribute('data-rpc-open'), op); return; }
    if (t.closest('[data-rpc-close]')){ e.preventDefault(); e.stopPropagation(); RPC.close(); return; }
    var fd = t.closest('[data-rpc-finder]');
    if (fd){ e.preventDefault(); e.stopPropagation(); RPC.close(true); var b = doc.querySelector('[data-lp-root] [data-open-finder]'); if (b) b.click(); return; }
    var qb = t.closest('[data-rpc-qty]');
    if (qb){ e.preventDefault(); e.stopPropagation(); var row = qb.closest('[data-key]'), cur = parseInt(row.getAttribute('data-qty'), 10) + parseInt(qb.getAttribute('data-rpc-qty'), 10);
      row.classList.add('is-busy'); RPC.cart.change(row.getAttribute('data-key'), Math.max(0, cur)).catch(function(err){ toast(err.message); paintCart(); }); return; }
    var rm = t.closest('[data-rpc-remove]');
    if (rm){ e.preventDefault(); e.stopPropagation(); var r2 = rm.closest('[data-key]'); r2.classList.add('is-busy'); RPC.cart.change(r2.getAttribute('data-key'), 0).catch(function(err){ toast(err.message); paintCart(); }); return; }
    var term = t.closest('[data-rpc-term]');
    if (term){ e.preventDefault(); e.stopPropagation(); var inp = visibleInput(layer('search')) || visibleInput(); if (inp){ inp.value = term.getAttribute('data-rpc-term'); runSuggest(inp); inp.focus(); } return; }
    var a = t.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    // in-page jump (announcement kit link): if this page has the target, scroll to it instead of leaving
    var jump = a.getAttribute('data-jump');
    if (jump){ var tgt = doc.querySelector('[data-anchor="' + jump + '"]'); if (tgt){ e.preventDefault(); e.stopPropagation(); RPC.close(true); tgt.scrollIntoView({ behavior:'smooth', block:'start' }); return; } }
    if (LIVE || !/^\//.test(href) || a.target === '_blank' || e.metaKey || e.ctrlKey) { e.stopPropagation(); return; }
    e.preventDefault(); e.stopPropagation(); RPC.close(true); RPC.go(href);
  }
  function onKey(e){
    if (e.key === 'Escape' && openName){ RPC.close(); return; }
    if (e.key === 'Tab' && openName){
      var L = layer(openName); if (!L || !L.hasAttribute('data-modal')) return;
      var f = focusables(L); if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]){ e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]){ e.preventDefault(); f[0].focus(); }
    }
  }
  function onSubmit(e){
    var sf = e.target.closest('[data-rpc-search-form]');
    if (sf){ var q = (sf.querySelector('[data-rpc-q]') || {}).value || ''; if (!q.trim()){ e.preventDefault(); return; } if (!LIVE){ e.preventDefault(); location.href = RPC.searchUrl(q.trim()); } return; }
    var cf = e.target.closest('[data-rpc-code-form]');
    if (cf){
      if (!cf.checkValidity()){ e.preventDefault(); cf.reportValidity(); return; }
      if (LIVE) return;    // real Shopify customer form POST; on return ?customer_posted=true shows the done state
      e.preventDefault(); codeDone(cf);
    }
  }
  function codeDone(cf){
    cf.querySelector('[data-step="ask"]').hidden = true; cf.querySelector('[data-step="done"]').hidden = false;
    if (W.RP && RP.leadHook) RP.leadHook('lead_submit', { form:'footer-10-off' });
  }
  function onInput(e){ var i = e.target.closest('[data-rpc-q]'); if (i) runSuggest(i); }

  /* outside click closes a non-modal layer (Shop by Case panel, Iteration 2's desktop search dropdown) */
  doc.addEventListener('click', function(e){
    if (!openName) return;
    var L = layer(openName); if (!L || L.hasAttribute('data-modal')) return;
    if (e.target.closest('[data-rpc-layer="' + openName + '"]') || e.target.closest('[data-rpc-open="' + openName + '"]') || e.target.closest('[data-rpc-anchor="' + openName + '"]')) return;
    RPC.close(true);
  });
  function visibleInput(scope){ return Array.prototype.filter.call((scope || doc).querySelectorAll('[data-rpc-q]'), function(i){ return i.offsetParent !== null; })[0]; }
  RPC.visibleInput = visibleInput;

  /* quick add on the host page (Module 6 card button): add the real product, then open the drawer.
     Capture phase, so the host page's own "Added" state still runs. */
  function quickAdd(e){
    var b = e.target.closest('[data-quickadd]'); if (!b) return;
    var card = b.closest('.pcard'), a = card && card.querySelector('a[href^="/products/"]'); if (!a) return;
    var h = a.getAttribute('href').replace(/^\/products\//, '').replace(/[?#].*$/, '');
    RPC.cart.addHandle(h, 1).then(function(){ RPC.open('cart', b); }).catch(function(err){ toast(err.message); });
  }

  /* ======================================================================
     MOUNT
     ====================================================================== */
  function frag(html){ var t = doc.createElement('template'); t.innerHTML = html; return t.content; }
  function bind(el){ el.addEventListener('click', onClick); el.addEventListener('submit', onSubmit); el.addEventListener('input', onInput); }

  RPC.mount = function(opts){
    opts = opts || {};
    var impl = RPC.impl, root = doc.querySelector('[data-lp-root]');
    if (!root || !impl) return;
    doc.documentElement.classList.add('rpc-it' + impl.id);
    var ctx = {
      page: root.getAttribute('data-page'),
      hasFinder: !!root.querySelector('[data-open-finder]'),
      // Onyx kill: a page that already asks for the email (homepage Get Code, landing page email section) does not get
      // a second identical ask in its footer. Every other page (search, PDP, collections, policies) does.
      showEmail: !root.querySelector('section .hp-code-form, section .lp-email-form, section form[data-lead-form]')
    };
    RPC.ctx = ctx;

    // 1) remove the stand-ins: Module 6 header, Module 9 hero announcement bar (the chrome owns the bar now), footer
    var oldHead = root.querySelector('.lp-header');
    root.querySelectorAll('.rp-stage > .announce-bar').forEach(function(x){ x.remove(); });
    var top = frag(impl.top(D, ctx));
    var topEls = Array.prototype.slice.call(top.children);
    if (oldHead) oldHead.replaceWith(top); else root.insertBefore(top, root.firstChild);
    var oldFoot = root.querySelector('.lp-footer');
    var foot = frag(impl.footer(D, ctx)), footEl = foot.firstElementChild;
    if (oldFoot) oldFoot.replaceWith(foot); else root.appendChild(foot);
    var layers = doc.createElement('div'); layers.className = 'rpc-layers rpc-it' + impl.id; layers.innerHTML = impl.overlays(D, ctx);
    doc.body.appendChild(layers);

    topEls.concat([footEl, layers]).forEach(bind);
    doc.addEventListener('keydown', onKey);
    root.addEventListener('click', quickAdd, true);

    var yr = new Date().getFullYear();
    doc.querySelectorAll('[data-rpc-year]').forEach(function(el){ el.textContent = yr; });
    // live store: Shopify redirects a successful customer form to ?customer_posted=true#rpc-code
    if (/customer_posted=true/.test(location.search)){ var cf = doc.querySelector('[data-rpc-code-form]'); if (cf) codeDone(cf); }
    W.addEventListener('storage', function(e){ if (e.key === MOCK_KEY) RPC.cart.get(); });   // other preview frames changed the cart

    if (impl.init) impl.init(RPC, D, ctx);
    doc.querySelectorAll('[data-rpc-results]').forEach(function(sb){ sb.innerHTML = impl.searchHTML(null, '', D); });
    RPC.cart.get().then(function(){ RPC.state(opts.state); });
  };

  /* review / screenshot states: ?state=cart|cart-full|cart-empty|menu|cases|search|scrolled */
  var SAMPLE = ['milwaukee-packout-48-22-8436-45-acp-ammo-holder-insert', 'milwaukee-packout-slim-low-profile-organizer-glock-magazine-holder-insert'];
  var SAMPLE_FULL = ['milwaukee-packout-48-22-8435-308-ammo-holder-insert', 'milwaukee-packout-9mm-ammo-storage-double-stack'];
  RPC.seed = function(list){
    if (LIVE) return Promise.resolve();
    Mock.clear(); list.forEach(function(h){ Mock.add(h, 1); }); return RPC.cart.get();
  };
  RPC.state = function(s){
    if (!s) return;
    var p = Promise.resolve();
    if (s === 'cart') p = RPC.seed(SAMPLE);
    if (s === 'cart-full') p = RPC.seed(SAMPLE_FULL);
    if (s === 'cart-empty') p = RPC.seed([]);
    p.then(function(){
      if (/^cart/.test(s)) RPC.open('cart');
      else if (s === 'menu') RPC.open('menu');
      else if (s === 'cases') RPC.open('cases');
      else if (s === 'search'){ var sl = (RPC.impl.searchLayer && RPC.impl.searchLayer()) || 'search'; RPC.open(sl); setTimeout(function(){ var i = visibleInput(layer(sl)) || visibleInput(); if (i){ i.value = '9mm'; runSuggest(i); } }, 120); }
      else if (s === 'scrolled'){ W.scrollTo(0, 1500); }
      else if (s === 'footer'){ setTimeout(function(){ W.scrollTo(0, doc.documentElement.scrollHeight); }, 300); }
    });
  };
})();
